/**
 * External Dependencies
 */

import handleFloatingLabels from './modules/floatingLabels';
import galleryCarousel from './modules/gallerySlider';
import handleHamburger from './modules/hamburger';
import handleGallery from './modules/handleGallery';
import hidingHeader from './modules/header';
import scalingHeader from './modules/header';
import homeCarousel from './modules/heroSlider';
import scroll from './modules/locomotive';

document.addEventListener('DOMContentLoaded', () => {
  scroll.update();
  homeCarousel();
  galleryCarousel();
  scalingHeader();
  hidingHeader();
  handleHamburger();
  handleFloatingLabels();
  handleGallery();
});
